import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserStorageService {
  constructor() {}

  get(key: string, driver = 'local'): string | null {
    if (driver === 'session') {
      return sessionStorage.getItem(key);
    }
    return localStorage.getItem(key);
  }

  set(key: string, value: string, driver = 'local'): void {
    if (driver === 'session') {
      sessionStorage.setItem(key, value);
      return;
    }

    localStorage.setItem(key, value);
  }

  remove(key: string, driver = 'local'): void {
    if (driver === 'session') {
      sessionStorage.removeItem(key);
      return;
    }

    localStorage.removeItem(key);
  }

  clear(driver = 'local'): void {
    if (driver === 'session') {
      sessionStorage.clear();
      return;
    }

    localStorage.clear();
  }
}
